import { GruppeTier } from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';
import { Gruppe } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';

export class IdentifikationDialogInput {
    gruppe: Gruppe;
    identifikation: string;
    prophylaxe: number;
    metaphylaxe: number;
    umwidmung: number;
    tiere: GruppeTier[] = [];
    anzahlTiere: number;
    tiereAnzeigen: boolean;
    checkboxenAnzeigen: boolean;
}
export class IdentifikationDialogResult {
    confirm = false;
    identifikationTyp: string;
    freitext: string;
    tiere: GruppeTier[] = [];
    alleSelektiert: boolean;
    prophylaxe: number;
    metaphylaxe: number;
    umwidmung: number;
}
